import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useLoan from 'hooks/useLoan';
import routes from 'resources/routes.json';
import { goToLoanRoute } from 'navigation/application-routes';
import { findCurrentLoan } from 'store/actions/customer-actions';
import CheckBox from 'components/UI/checkbox/checkbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import InsuranceTermsComponent from '../../../components/features/insurance-block/insurance-terms';

import {
  applyForInsurance,
  cancelInsurance,
  APPLY_FOR_INSURANCE_SUCCESS,
  CANCEL_INSURANCE_SUCCESS,
} from '../../../store/actions/application-actions';

import { showFooter, showMenu } from '../../../store/actions/util-actions';
import { default as ButtonOld } from '../../../components/UI/button/button';
import styles from './styles.module.scss';

import { Box, Button, Container, Icons, Typography } from 'lib-ui-react';
import checkIcon from '../../../../image/checkNew.png';
import { isMobile } from '../../../utils/helper/page-behavior-helper';

import { isRecurring } from '../../../utils/helper/loan-helper';

function InsuranceOfferPage() {
  sessionStorage.setItem('confirmedInsurance', true);

  const dispatch = useDispatch();
  const { loan, device, findLoanAndRedirect } = useLoan();
  const { ApprovedShieldIcon } = Icons;
  const IS_RECURRING = isRecurring(loan)

  const [insuranceLoading, setInsuranceLoading] = useState(false);
  const [insuranceRequested, setInsuranceRequested] = useState(
    loan?.application?.financial?.insuranceRequested || true,
  );
  const [showInsuranceTermsModal, setShowInsuranceTermsModal] = useState(false);

  const footerStyle = isMobile() ? { position: 'fixed', bottom: 0, left: 0 } : {};

  const handleShowTermsClick = (e) => {
    e.preventDefault();
    setShowInsuranceTermsModal(!showInsuranceTermsModal);
  };

  // Show menu and footer
  useEffect(() => {
    dispatch(showMenu(true));
    dispatch(showFooter(true));
  }, [dispatch]);

  useEffect(() => {
    if (loan?.labels2?.multivariateTests.includes('2023-03-insurancePage-offerNotAssigned')) {
      setInsuranceRequested(false);
    }

    if (!loan.id) {
      findLoanAndRedirect()
    }

  }, []);

  function handleApplyForInsurance() {
    setInsuranceLoading(true);
    sessionStorage.setItem('SHOW_INSURANCE_OFFER', false);

    if (insuranceRequested) {
      dispatch(applyForInsurance(device)).then((response) => {
        if (response.type === APPLY_FOR_INSURANCE_SUCCESS) {
          dispatch(findCurrentLoan(device)).then(() => {
            goToLoanRoute(loan, routes.LOAN_APPLICATION_CONTRACT);
          });
        }

        setInsuranceLoading(false);
      });
    } else {
      dispatch(findCurrentLoan(device)).then(() => {
        goToLoanRoute(loan, routes.LOAN_APPLICATION_CONTRACT);
        setInsuranceLoading(false);
      });
    }
  }

  function handleCancelInsurance() {
    setInsuranceLoading(true);
    sessionStorage.setItem('SHOW_INSURANCE_OFFER', false);

    if (!insuranceRequested) {
      dispatch(cancelInsurance(device)).then((response) => {
        if (response.type === CANCEL_INSURANCE_SUCCESS) {
          dispatch(findCurrentLoan(device)).then(() => {
            goToLoanRoute(loan, routes.CUSTOMER_INSURANCE_OFFER_PAGE);
          });
        }

        setInsuranceLoading(false);
      });
    } else {
      dispatch(findCurrentLoan(device)).then(() => {
        goToLoanRoute(loan, routes.CUSTOMER_INSURANCE_OFFER_PAGE);
        setInsuranceLoading(false);
      });
    }

  }

  return IS_RECURRING ? (
    <Container align="center">
      <Container align="center" width="100%" background="#fff" maxWidth="480px">
        <Container
          align="center"
          justify="center"
          direction="row"
          spacing={10}
          padding={10}
          background="#fff"
          width="100%"
          style={{ color: '#2a2b35' }}
        >
          <ApprovedShieldIcon />
          <Container spacing={4} width="auto">
            <Typography type="title" size="medium" fontWeight={700} lineHeight="24px">
              Seguro SuperSim
            </Typography>
            <Typography size="caption" fontWeight={400} lineHeight="16px">
              Seu empréstimo protegido
            </Typography>
          </Container>
        </Container>
        <Container spacing={32} padding={16}>
          <Container
            spacing={8}
            padding="16px 31px 16px 31px"
            background="#F5F5F5"
            style={{ boxSizing: 'border-box', border: '1px solid #EEEEEE', borderRadius: '8px' }}
          >
            <Container align="center" justify="center" spacing={16}>
              <Typography type="title" size="small" fontWeight={700} lineHeight="28px" center>
                Proteção garantida contra
              </Typography>

              <Container spacing={16}>
                <Box display="flex" direction="row" gap="8px" align="center">
                  <img src={checkIcon} width={16} height={16} alt="Imagem de confirmado" />
                  <Typography size="medium" fontWeight={400} lineHeight="16px">
                    Perda do emprego CLT
                  </Typography>
                </Box>
                <Box display="flex" direction="row" gap="8px" align="center">
                  <img src={checkIcon} width={16} height={16} alt="Imagem de confirmado" />
                  <Typography size="medium" fontWeight={400} lineHeight="16px">
                    Morte ou invalidez
                  </Typography>
                </Box>
                <Box display="flex" direction="row" gap="8px" align="center">
                  <img src={checkIcon} width={16} height={16} alt="Imagem de confirmado" />
                  <Typography size="medium" fontWeight={400} lineHeight="16px">
                    Acidentes
                  </Typography>
                </Box>
              </Container>
            </Container>
          </Container>
          <Container spacing={4}>
            <Typography size="caption" fontWeight={700} lineHeight="20px" center>
              Menos de <span style={{ fontSize: '14px' }}>50 centavos</span> por dia!
            </Typography>
            <Typography size="caption" fontWeight={400} lineHeight="20px" center>
              Cancele em até <span style={{ fontSize: '14px' }}>10 dias de graça.</span>
            </Typography>
          </Container>
          <Container spacing={4}>
            <Typography size="small" fontWeight={700} lineHeight="18px" center>
              Você ainda concorre a
            </Typography>
            <Typography style={{ fontSize: '28px', fontWeight: 700, lineHeight: '28px', textAlign: 'center' }}>
              R$ 5.000,00
            </Typography>
            <Typography size="small" fontWeight={700} lineHeight="14px" center>
              todo mês**
            </Typography>
          </Container>
          <Container padding="0px 25px">
            <Typography
              style={{
                fontSize: '9px',
                fontWeight: 400,
                lineHeight: '11px',
                letterSpacing: '0.75px',
                textAlign: 'justify',
              }}
            >
              *Dívidas de até R$ 5.000 após comprovação do fator gerador (acidente, doença sem pré-existência, morte, ou
              perda de emprego CLT de mais de 9 meses) ** Enquanto a cobertura e o empréstimo estiverem ativos.
            </Typography>
          </Container>
        </Container>
        <Container
          align="center"
          justify="center"
          padding="16px"
          spacing={8}
          background="#fff"
          width="100%"
          style={footerStyle}
        >
          <Container padding="0 32px">
            <Typography size="caption" fontWeight={400} lineHeight="16px" center>
              Ao Continuar você confirma que leu e aceita os{' '}
              <a href="#" onClick={handleShowTermsClick}>
                <span style={{ color: '#ff971e' }}>termos e condições</span>
              </a>
            </Typography>
          </Container>
          <Button
            id="insuranceConfirmedContinueButton"
            disabled={insuranceLoading}
            onClick={handleApplyForInsurance}
            margin="0"
          >
            Proteger meu empréstimo
          </Button>
          <Button
            id="insuranceUnconfirmedContinueButton"
            disabled={insuranceLoading}
            onClick={handleCancelInsurance}
            outlined
            borderColor="#E0E0E0"
            color="#757575"
            margin="0"
          >
            Prefiro não me proteger
          </Button>
        </Container>
      </Container>
      {showInsuranceTermsModal && <InsuranceTermsComponent handleShowTerms={handleShowTermsClick} />}
    </Container>
  ) : (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className={styles.desktopScreenContainer}>
        <div className={`${styles.title}`}>
          <span>
            <img src="/image/insurance_icon.png" width={50} alt="Imagem de confirmado" />
          </span>
          <p>
            Seguro SuperSim <br />
            <span>Seu empréstimo protegido</span>
          </p>
        </div>
        <div className={styles.main}>
          <div>
            <p className={`${styles.gradient} ${styles.titleList} `}>
              <span>Proteção contra</span>
            </p>

            <p className={styles.listItens}>
              <span>Perda do emprego CLT.</span>
              <span>
                <img src="/image/check.png" width={20} alt="Imagem de confirmado" />
              </span>
            </p>
            <p className={styles.listItens}>
              <span>Morte ou invalidez.</span>
              <span>
                <img src="/image/check.png" width={20} alt="Imagem de confirmado" />
              </span>
            </p>
            <p className={styles.listItens}>
              <span>Acidentes.</span>
              <span>
                <img src="/image/check.png" width={20} alt="Imagem de confirmado" />
              </span>
            </p>
          </div>
          <p>
            <span>
              <b>Menos de 50 centavos</b> por dia!
            </span>
            <br />
            <span>
              <b>Cancele em até</b> 10 dias de graça.
            </span>
          </p>

          <div>
            <p className={`${styles.titleList} ${styles.gradient}`}>
              <span>Você ainda concorre a</span>
              <br />
              <span className={styles.cash}>R$ 5.000,00</span>
              <br />
              <span>todo mês**</span>
            </p>
          </div>
          <div>
            <span>
              <CheckBox
                id={'insuranceRequested-' + insuranceRequested}
                mandatory
                validationPattern="true"
                validationMessage=""
                errorClassName="error"
                className="field-large checkbox-consent"
                value={insuranceRequested}
                checked={insuranceRequested}
                onChange={(value) => setInsuranceRequested(value)}
              />
            </span>

            <p style={{ fontWeight: '400' }}>
              Aceito proteger meu empréstimo e concordo com os{' '}
              <a href="#" onClick={handleShowTermsClick}>
                <span style={{ color: '#ff971e' }}>termos e condições</span>
              </a>
            </p>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          {insuranceLoading && <FontAwesomeIcon icon={faSpinner} size="2x" className="fa-spin mb-1" />}
          {insuranceRequested ? (
            <ButtonOld
              id="insuranceConfirmedContinueButton"
              disabled={insuranceLoading}
              onClick={handleApplyForInsurance}
            >
              Continuar meu empréstimo
            </ButtonOld>
          ) : (
            <ButtonOld
              id="insuranceUnconfirmedContinueButton"
              disabled={insuranceLoading}
              onClick={handleCancelInsurance}
            >
              Continuar meu empréstimo
            </ButtonOld>
          )}
        </div>
        <div className={styles.footer}>
          <p>
            *Dívidas de até R$ 5.000 após comprovação do fator gerador (acidente, doença sem pré-existência, morte, ou
            perda de emprego CLT de mais de 9 meses) ** Enquanto a cobertura e o empréstimo estiverem ativos.
          </p>
        </div>
      </div>
      {showInsuranceTermsModal && <InsuranceTermsComponent handleShowTerms={handleShowTermsClick} />}
    </div>
  );
}

export default InsuranceOfferPage;
